import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { authentication } from './authentication.module'
import { countries } from './countries.module'
import { positions } from './positions.module'
import { socialRegistration } from './socialRegistration.module'
import { parentConsentPopup } from './parentConsentPopup.module'

Vue.use(Vuex)

export const store: any = new Vuex.Store({
  modules: {
    alert,
    socialRegistration,
    authentication,
    countries,
    positions,
    parentConsentPopup,
  },
})
